const moduleMap = {
	"./general/api/config": () => {
		return __webpack_require__.e(6478).then(() => (() => ((__webpack_require__(6478)))));
	},
	"./general/api/makeRequest": () => {
		return Promise.all([__webpack_require__.e(1034), __webpack_require__.e(8100)]).then(() => (() => ((__webpack_require__(8100)))));
	},
	"./general/api/makeSSEConnection": () => {
		return Promise.all([__webpack_require__.e(1034), __webpack_require__.e(616)]).then(() => (() => ((__webpack_require__(616)))));
	},
	"./stores/useSystemStore": () => {
		return Promise.all([__webpack_require__.e(1034), __webpack_require__.e(1182), __webpack_require__.e(6492)]).then(() => (() => ((__webpack_require__(6492)))));
	},
	"./VCameraSelector": () => {
		return Promise.all([__webpack_require__.e(1034), __webpack_require__.e(8740), __webpack_require__.e(1182), __webpack_require__.e(3996)]).then(() => (() => ((__webpack_require__(3996)))));
	},
	"./VEventsBlockComponent": () => {
		return __webpack_require__.e(5689).then(() => (() => ((__webpack_require__(5689)))));
	},
	"./VPermissionsTableComponent": () => {
		return __webpack_require__.e(1448).then(() => (() => ((__webpack_require__(1448)))));
	},
	"./VTooltip": () => {
		return __webpack_require__.e(725).then(() => (() => ((__webpack_require__(725)))));
	},
	"./VPagination": () => {
		return __webpack_require__.e(8266).then(() => (() => ((__webpack_require__(8266)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});